/**
 * LiveSpeaking — qui parle, sur chaque vignette du live (ses barres vertes, son liseré) et sur le bouton de mon micro :
 * l'écran du tuteur et celui de l'élève posent cette source au-dessus de leur page (`SpeakingContext`), lue sur
 * l'événement « parle / se tait » de LiveKit (`engine/live/room/speakingSource`). Seules les vignettes de qui se met à
 * parler ou se tait se redessinent ; la page, jamais.
 */
import { useMaybeRoomContext } from "@livekit/components-react"
import React, { type ReactNode, useMemo } from "react"

import { SpeakingContext } from "../../../../../../design-system"
import { speakingSource } from "../../../../../../engine/live/room/speakingSource"

export function LiveSpeaking({ children }: { children: ReactNode }) {
    // Hors d'une salle (une page rendue avant la séance, un test) : personne ne parle.
    const room = useMaybeRoomContext()
    const source = useMemo(() => (room == null ? null : speakingSource(room)), [room])
    return <SpeakingContext.Provider value={source}>{children}</SpeakingContext.Provider>
}
